// extracted by mini-css-extract-plugin
export default {"cls1":"Comments-cls1___907fb796a2812cfdf8e","cls2":"Comments-cls2__ee171f7876d2a10a719d Comments-cls1___907fb796a2812cfdf8e"};